window.addEventListener("scroll", function () {
  var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  var chatElement = document.getElementById("shopify-chat");

  if (chatElement) {
    if (scrollPosition > 200) {
      chatElement.style.display = "block";
    } else {
      chatElement.style.display = "none";
    }
  }
});
